import {CalendarEvent, CalendarEventTitleFormatter} from 'angular-calendar';
import {Injectable} from '@angular/core';
import * as moment from 'moment';

@Injectable()
export class CustomEventTitleFormatterProvider extends CalendarEventTitleFormatter {

  private getTitleAttribute(event: CalendarEvent, title: string) {

    if (event.meta.note_cliente && ['trattamento', 'mantenimento'].indexOf(event.meta.type) !== -1 && ['confirmed', 'to_be_confirmed'].indexOf(event.meta.stato) === -1) {
      return `${title} (Note cliente: ${event.meta.note_cliente})`;
    }

    if (event.meta.servizio_nome) {
      title = `${title} (${event.meta.servizio_nome} ${event.meta.servizio_durata.substr(0, 5)})`;
    }

    return title;

  }

  private getNomeCliente(event: CalendarEvent): string {

    let eventTitle = '';

    if (event.meta && event.meta.hasOwnProperty('cliente') && event.meta.cliente) {
      if (event.meta.servizio_nome && event.meta.servizio_nome.indexOf('Trico Piega Bellessere') !== -1) {
        eventTitle = 'P - ';
      }
      eventTitle += event.meta.cliente + ': ';
    }

    return eventTitle;

  }

  composeTitle(event: CalendarEvent, title: string) {}

  week(event: CalendarEvent, title: string): string {

    const returnedTitle = this.getTitleAttribute(event, title);
    if (!event.allDay) {
      if (event.meta.type === 'chiusura') {
        return 'CHIUSURA';
      }

      if (event.meta.beauty_type === 'note') {
        return `Nota: ${event.meta.description}`;
      }

      let eventTitle = `${moment(event.start).format('HH:mm')} - `;

      eventTitle += this.getNomeCliente(event);

      eventTitle += returnedTitle;

      if(event.meta && event.meta.note) {
        eventTitle += ' (' + event.meta.note + ')';
      }

      // if (event.meta.user) {
      //   eventTitle += ' - ' + event.meta.user.name;
      // }

      return eventTitle;
    }
    return returnedTitle;
  }

  day(event: CalendarEvent, title: string): string {

    const returnedTitle = this.getTitleAttribute(event, title);
    if (!event.allDay) {
      if (event.meta.type === 'chiusura') {
        return 'CHIUSURA';
      }


      let eventTitle = `${moment(event.start).format('HH:mm')} - `;

      if (event.meta && event.meta.hasOwnProperty('cliente') && event.meta.cliente) {
        eventTitle += event.meta.cliente + ': ';
      }
      eventTitle += returnedTitle;

      if(event.meta && event.meta.note) {
        eventTitle += ' (' + event.meta.note + ')';
      }

      return eventTitle;
    }

    return returnedTitle;

  }

}
